import { PntStationStatusItemDtoV2 } from '@mi-front/core';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { closeDialogMessage } from '../spot/schedule-status-spot-messages';
import { ScheduleStatusSpotStatusChip } from '../spot/ScheduleStatusSpotStatusChip';

interface ScheduleStatusMentionsDetailHeaderProps {
  item: PntStationStatusItemDtoV2;
  onHide: () => void;
}

/**
 * Dialog header: mention ID, coverage chip, and close.
 */
export function ScheduleStatusMentionsDetailHeader({
  item,
  onHide,
}: ScheduleStatusMentionsDetailHeaderProps) {
  const { $t } = useIntl();

  return (
    <DialogTitle
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.5, flexWrap: 'nowrap' }}
    >
      <Typography variant="h6" component="span" noWrap sx={{ minWidth: 0 }}>
        {item.customId}
      </Typography>
      <ScheduleStatusSpotStatusChip status={item.status} />
      <Box sx={{ flexGrow: 1 }} />
      <Tooltip title={$t(closeDialogMessage)}>
        <IconButton onClick={onHide} sx={{ my: 0 }}>
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </DialogTitle>
  );
}
